import api from "@/services/api";

export interface ConfirmPagBankSmsPayload {
  sms_code: string;
}

export interface ConfirmPagBankSmsResponse {
  connected: boolean;
}

class ConfirmPagBankSms {
  execute = async (payload: ConfirmPagBankSmsPayload) => {
    const response = await api().post(
      "/partner/pagbank-connect/sms/confirm",
      payload
    );
    return response.data as ConfirmPagBankSmsResponse;
  };
}

export { ConfirmPagBankSms };
